import { SelectOption } from '@zencity/common-ui/lib/ZCD/ZCDFilter/types';
import React, { ReactElement, useContext, useState } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { ReportBuilderFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/constants';
import { SurveysSelection } from 'screens/WidgetGenerator/widgetAdditionalFields/utilsFunctionsAdditionalFields/SurveysSelection';

export const SurveySelectFilter = (props: ReportBuilderFilterProps): ReactElement => {
  const { value: filterValue, onChange } = props;
  const filteredValue = filterValue as SelectOption | undefined;
  const [selectedSurveyId, setSelectedSurveyId] = useState<number>(filteredValue?.value as number);
  const { client, selectedSurveyGroup } = useContext(WidgetGeneratorContext);
  const handleOnSelectSurvey = (selectedSurveyOption: unknown) => {
    const selectedOption = selectedSurveyOption as SelectOption;
    setSelectedSurveyId(selectedOption.value as number);
    onChange(selectedOption);
  };

  return (
    <SurveysSelection
      handleSelectSurvey={handleOnSelectSurvey}
      selectedSurvey={selectedSurveyId}
      shouldSelectDefaultSurvey
      selectedSurveyGroup={selectedSurveyGroup.id}
      client={client}
    />
  );
};
